module.exports = __webpack_public_path__ + "img/Flecha.8f492456.svg";